/* NOVAWEAR UX customer events — no PII, no standard-commerce duplicates. */
(function () {
  'use strict';

  function publish(name, data) {
    try {
      if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
      Shopify.analytics.publish(name, data || {});
    } catch (error) {
      // Tracking must never interrupt shopping interactions.
    }
  }

  function context() {
    return {
      page_path: window.location.pathname,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    };
  }

  function text(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim().slice(0, 120);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var stickyAdd = target.closest('[data-sticky-add-to-cart], .sticky-add-to-cart [data-add-to-cart], [data-sticky-atc]');
    if (stickyAdd) {
      publish('nw_sticky_add_to_cart_clicked', Object.assign(context(), {
        variant_id: String((document.querySelector('input[name="id"]') || {}).value || '')
      }));
      return;
    }

    var faq = target.closest('.faq__list button, [data-faq] button, .faq summary');
    if (faq) {
      publish('nw_faq_interacted', Object.assign(context(), { question: text(faq) }));
      return;
    }

    var productInfo = target.closest('.pdp__accordions button, [data-product-accordion] button');
    if (productInfo) {
      publish('nw_product_info_interacted', Object.assign(context(), { section: text(productInfo) }));
      return;
    }

    var reviewEntry = target.closest('[href*="#loox"], [href*="reviews"], [data-reviews-link], [data-loox-button]');
    if (reviewEntry) {
      publish('nw_review_interaction', Object.assign(context(), { label: text(reviewEntry) }));
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    var newsletter = form.matches('[data-newsletter-form], .newsletter-form') ||
      !!form.querySelector('input[name="contact[tags]"][value*="newsletter" i]');
    if (!newsletter) return;
    publish('nw_newsletter_form_submitted', context());
  }, true);
})();
